import adminDashboardImg from '@assets/images/features_admindashboard.png';
import rewardsImg from '@assets/images/features_rewards.png';
import kudosImg from '@assets/images/features_kudos.png';
import eventsImg from '@assets/images/features_events.png';
import quizsurveyImg from '@assets/images/features_quizsurvey.png';
import analyticsImg from '@assets/images/features_analytics.png';

const features = [
  {
    title: 'Kudos',
    emoji: '💞',
    image: kudosImg,
    bullets: [
      'Foster positivity and teamwork by enabling employees to share genuine appreciation, nurturing a thriving workplace culture.',
    ],
  },
  {
    title: 'Rewards Redemption',
    emoji: '🎁',
    image: rewardsImg,
    bullets: [
      'Engage employees with delightful rewards, turning everyday tasks into exciting opportunities for recognition and growth.',
    ],
  },
  {
    title: 'Events',
    emoji: '🎉',
    image: eventsImg,
    bullets: [
      'Seamlessly manage events and attendance, ensuring every moment counts in fostering connections and learning.',
    ],
  },
  {
    title: 'Quiz & Survey',
    emoji: '✍️',
    image: quizsurveyImg,
    bullets: [
      ' Elevate engagement with enjoyable quizzes and gain valuable insights through employee surveys, enhancing understanding and satisfaction.',
    ],
  },
  {
    title: 'Analytics',
    emoji: '📊',
    image: analyticsImg,
    bullets: [
      'Unlock profound insights into user and employee data, tailor reports to your needs, and fuel informed decisions for a more impactful workforce strategy.',
    ],
  },
  {
    title: 'Admin Controls & Customization',
    emoji: '🛠',
    image: adminDashboardImg,
    bullets: [
      'Empower your team with an intuitive admin portal, effortlessly manage content, and access insightful reports for strategic growth.',
    ],
  },
];

export default features;
